


















































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxScrollView, DxLoadPanel } from 'devextreme-vue';

import { Icon } from '@/core/components/controls';
import {
    SiteGroup as SiteGroupData,
    IRequestsData,
    DataCategory,
    LocalizationKeys,
    IExpandedState,
    IResourcesData,
    IMtrChartData,
    ILoadingState,
} from '../classes';
import {
    CollapsedRequestsChart,
    ExpandedRequestsChart,
    IncomeMtrChart,
    OutcomeMtrChart,
    TechnicsChart,
    ResourceChart,
} from './';

function toGroups(value: number): string {
    return value
        .toString()
        .split(/(?=(?:\d{3})+(?:\.|$))/g)
        .join(' ');
}

@Component({
    components: {
        Icon,
        DxScrollView,
        DxLoadPanel,
        CollapsedRequestsChart,
        ExpandedRequestsChart,
        IncomeMtrChart,
        OutcomeMtrChart,
        TechnicsChart,
        ResourceChart,
    },
    filters: {
        toGroups,
    },
})
export default class SiteGroup extends Vue {
    private static idCounter: number = 0;

    public DataCategory = DataCategory;
    public LocalizationKeys = LocalizationKeys;

    @Prop({ required: true })
    public siteGroup?: SiteGroupData;
    private readonly id: number = ++SiteGroup.idCounter;

    private mounted(): void {
        if (!this.siteGroup) {
            throw new Error('siteGroup data is not set');
        }
    }

    private get unit() {
        return this.siteGroup?.unit;
    }

    private get isSecondStageLoaded(): boolean {
        return this.siteGroup!.parent.isSecondStageLoaded;
    }
    private get showRequestsBlock(): boolean {
        return (
            this.isSecondStageLoaded ||
            this.isCategorySelected(DataCategory.IncomeMtr) ||
            this.isCategorySelected(DataCategory.Technics) ||
            this.isCategorySelected(DataCategory.Storekeepers) ||
            this.isCategorySelected(DataCategory.OtherEmployers)
        );
    }

    private get isExpanded(): boolean {
        return this.siteGroup!.isExpanded;
    }
    private get name(): string {
        return this.siteGroup!.name;
    }
    private get stockWeight(): number {
        return Math.round(this.siteGroup!.stockWeight);
    }
    private get incomeRelocationsWeight(): number {
        return Math.round(this.siteGroup!.incomeRelocationsWeight);
    }
    private get lossRelocationsWeight(): number {
        return Math.round(this.siteGroup!.lossRelocationsWeight);
    }
    private get requestsTotalCount(): number {
        let result;

        const category = this.siteGroup!.selectedDataCategory;
        switch (category) {
            case DataCategory.IncomeMtr:
            case DataCategory.Technics:
            case DataCategory.Storekeepers:
            case DataCategory.OtherEmployers:
                result = this.siteGroup!.incomeRequests.getTotalRequestCount();
                break;
            case DataCategory.OutcomeMtr:
                result = this.siteGroup!.outcomeRequests.getTotalRequestCount();
                break;
            default:
                throw new Error(
                    `DataCategory value '${category}' is not supoorted`
                );
        }

        return result;
    }
    private get requestsData(): IRequestsData {
        let result;

        const category = this.siteGroup!.selectedDataCategory;
        switch (category) {
            case DataCategory.IncomeMtr:
            case DataCategory.Technics:
            case DataCategory.Storekeepers:
            case DataCategory.OtherEmployers:
                result = this.siteGroup!.incomeRequests;
                break;
            case DataCategory.OutcomeMtr:
                result = this.siteGroup!.outcomeRequests;
                break;
            default:
                throw new Error(
                    `DataCategory value '${category}' is not supoorted`
                );
        }

        return result;
    }

    private get resourcesData(): IResourcesData &
        IExpandedState &
        ILoadingState {
        const me = this;
        return {
            resources: this.siteGroup!.resourceStackRecords,
            ...{
                get isExpanded(): boolean {
                    return me.siteGroup!.isExpanded;
                },
                get isLoaded(): boolean {
                    return me.siteGroup!.parent.isSecondStageLoaded;
                },
            },
        };
    }

    private get technicsData(): IResourcesData &
        IExpandedState &
        ILoadingState {
        const me = this;
        return {
            vehicles: this.siteGroup!.vehicleChartRecords,
            cranes: this.siteGroup!.craneChartRecords,
            ...{
                get isExpanded(): boolean {
                    return me.siteGroup!.isExpanded;
                },
                get isLoaded(): boolean {
                    return me.siteGroup!.parent.isSecondStageLoaded;
                },
            },
        };
    }

    private get incomeMtrData(): IMtrChartData & IExpandedState {
        const me = this;
        return {
            records: this.siteGroup!.income,
            ...{
                get isExpanded(): boolean {
                    return me.siteGroup!.isExpanded;
                },
            },
        };
    }

    private get outcomeMtrData(): IMtrChartData &
        IExpandedState &
        ILoadingState {
        const me = this;
        return {
            records: this.siteGroup!.outcome,
            ...{
                get isExpanded(): boolean {
                    return me.siteGroup!.isExpanded;
                },
                get isLoaded(): boolean {
                    return me.siteGroup!.parent.isSecondStageLoaded;
                },
            },
        };
    }

    private isCategorySelected(category: DataCategory): boolean {
        return this.siteGroup!.selectedDataCategory === category;
    }

    private onExpanderClick(): void {
        this.siteGroup!.isExpanded = !this.siteGroup!.isExpanded;
    }
}
